var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitorConnectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19C15 18.7348 14.8946 18.4804 14.7071 18.2929C14.5196 18.1054 14.2652 18 14 18H13V16C34.4499 16 -8.80396 16 11 16V18H10C9.73478 18 9.48043 18.1054 9.29289 18.2929C9.10536 18.4804 9 18.7348 9 19H2V21H9C9 21.2652 9.10536 21.5196 9.29289 21.7071C9.48043 21.8946 9.73478 22 10 22H14C14.2652 22 14.5196 21.8946 14.7071 21.7071C14.8946 21.5196 15 21.2652 15 21H22V19H15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 4.77778H18.4V13.6667H5.6M18.4 15.4444C18.8243 15.4444 19.2313 15.2571 19.5314 14.9237C19.8314 14.5903 20 14.1382 20 13.6667V4.77778C20 3.79111 19.28 3 18.4 3H5.6C4.712 3 4 3.79111 4 4.77778V13.6667C4 14.1382 4.16857 14.5903 4.46863 14.9237C4.76869 15.2571 5.17565 15.4444 5.6 15.4444H8.75703V16.3333H15.157V15.4444H18.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorConnectedIcon);
export default __webpack_public_path__ + "static/media/monitor-connected-icon.f2d95d23b95f66431c6ecfe7decb4fa3.svg";
export { ForwardRef as ReactComponent };